import { Paper, type SxProps, type Theme } from "@mui/material";
import clsx from "clsx";
import { ReactNode } from "react";

import styles from "./RegularContainer.module.scss";

interface IRegularContainerContextType {
    containerClasses?: string;
    sx?: SxProps<Theme>;
    id?: string;
}

const RegularContainer = ({
    children,
    containerClasses,
    sx,
    id,
}: IRegularContainerContextType & { children: ReactNode }) => {
    return (
        <Paper sx={sx} className={clsx(styles.wrapper, containerClasses)} data-testid='regular-container' id={id}>
            {children}
        </Paper>
    );
};

const Heading = ({
    title,
    actionButtons,
    headingClasses,
    subtitle,
}: {
    title?: string;
    actionButtons?: ReactNode;
    headingClasses?: string;
    subtitle?: string;
}) => {
    return (
        <div className={clsx(styles.headingBox, { [styles.headingMB]: true }, headingClasses)}>
            {title && <h2 className={styles.headingTitle}>{title}</h2>}
            {subtitle && <p className={styles.headingSubtitle}>{subtitle}</p>}
            {actionButtons && <div className={styles.actionWrapper}>{actionButtons}</div>}
        </div>
    );
};

const Content = ({ children, customClass, id }: { children: ReactNode; customClass?: string; id?: string }) => {
    return (
        <div className={clsx(customClass)} id={id}>
            {children}
        </div>
    );
};

RegularContainer.Heading = Heading;
RegularContainer.Content = Content;
export default RegularContainer;
